export default __webpack_public_path__ + "static/media/rating.65a7e807.svg";